// extracted by mini-css-extract-plugin
export var textInput = "_lj-0";